"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfLanguageItemDto = instanceOfLanguageItemDto;
exports.LanguageItemDtoFromJSON = LanguageItemDtoFromJSON;
exports.LanguageItemDtoFromJSONTyped = LanguageItemDtoFromJSONTyped;
exports.LanguageItemDtoToJSON = LanguageItemDtoToJSON;
exports.LanguageItemDtoToJSONTyped = LanguageItemDtoToJSONTyped;
/**
 * Check if a given object implements the LanguageItemDto interface.
 */
function instanceOfLanguageItemDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('code' in value) || value['code'] === undefined)
        return false;
    if (!('englishName' in value) || value['englishName'] === undefined)
        return false;
    if (!('nativeName' in value) || value['nativeName'] === undefined)
        return false;
    return true;
}
function LanguageItemDtoFromJSON(json) {
    return LanguageItemDtoFromJSONTyped(json, false);
}
function LanguageItemDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'code': json['code'],
        'englishName': json['englishName'],
        'nativeName': json['nativeName'],
    };
}
function LanguageItemDtoToJSON(json) {
    return LanguageItemDtoToJSONTyped(json, false);
}
function LanguageItemDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'code': value['code'],
        'englishName': value['englishName'],
        'nativeName': value['nativeName'],
    };
}
